import styled from "styled-components";
import { StyledModal } from "../../common/shared/modal.styled";

export const StyledNewBuildingAddressModal = styled(StyledModal)`
    .modal-dialog {
        max-width: 70%;

        h5 {
            width: fit-content;
        }

        .modal-body, .title-wrapper {
            display: flex;
            flex-direction: column;
        }

        .inputs-wrapper {
            display: grid;
            grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
            gap: 10px;
            margin-bottom: 20px;
        }

        .small-input {
            padding: 15px;
            height: 50px;
        }

        label {
            margin-bottom: 5px;
        }

        .title-input {
            width: 50%
        }
    }
`

export const StyledButton = styled.button`
    background-color: var(--bllink-purple);
    height: 52px;
    text-transform: uppercase;
    border-radius: 50px;
    border: none;
    color: white;
    width: 200px;
    margin-top: 20px;
    cursor: pointer;
    &:hover {
        background-color: #454bff;
    };
    &:disabled {
        background-color: #a9a9a9;
    };
`